import React from 'react';
import { LayoutDashboard, Users, Settings, HeadsetIcon, BarChart3, UserCircle, PhoneCall, DollarSign } from 'lucide-react';
import type { UserRole } from '../lib/auth';

interface SidebarProps {
  activeView: string;
  onViewChange: (view: string) => void;
  userRole: UserRole;
  isOpen: boolean;
}

export function Sidebar({ activeView, onViewChange, userRole, isOpen }: SidebarProps) {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, roles: ['user', 'support', 'admin'] },
    { id: 'call-logs', label: 'Call Logs', icon: PhoneCall, roles: ['user', 'support', 'admin'] },
    { id: 'agents', label: 'Agents', icon: HeadsetIcon, roles: ['user', 'support', 'admin'] },
    { id: 'users', label: 'Users', icon: Users, roles: ['admin'] },
    { id: 'analytics', label: 'Analytics', icon: BarChart3, roles: ['support', 'admin'] },
    { id: 'settings', label: 'Settings', icon: Settings, roles: ['admin'] },
    { id: 'billing', label: 'Billing', icon: DollarSign, roles: ['user', 'support', 'admin'] },
    { id: 'account', label: 'Account', icon: UserCircle, roles: ['user', 'support', 'admin'] }
  ];

  const filteredItems = menuItems.filter(item => item.roles.includes(userRole));

  return (
    <div className={`fixed top-0 left-0 h-screen bg-zinc-900 border-r border-zinc-800 transition-all duration-300 ${
      isOpen ? 'w-64 translate-x-0' : 'w-64 -translate-x-full'
    }`}>
      <div className="h-16 flex items-center px-4 border-b border-zinc-800">
        <span className="text-lg font-semibold text-white">Menu</span>
      </div>
      <div className="p-4">
        <nav className="space-y-1">
          {filteredItems.map((item) => (
            <button
              key={item.id}
              onClick={() => onViewChange(item.id)}
              className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg transition ${
                activeView === item.id
                  ? 'bg-emerald-500/10 text-emerald-400'
                  : 'text-zinc-400 hover:bg-zinc-800/50 hover:text-zinc-300'
              }`}
            >
              <item.icon className="w-5 h-5" />
              <span>{item.label}</span>
            </button>
          ))}
        </nav>
      </div>
    </div>
  );
}